import css from './deckPanel.module.scss';

import { memo } from 'react';

import { parseTimeDuration } from 'core/helpers/text';

type TProps = { date: string };
const PendingLabel: React.FC<TProps> = ({ date }) => {
  const duration = parseTimeDuration(date);
  return (
    <span className={css.exeWordsPendingTime}>
      {duration.sign}
      {Math.abs(duration.count)}
      {duration.label}
    </span>
  );
};

export default memo(PendingLabel);
